let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9bXCA")).then(() => parcelRequire('4zQBS'));